<script lang="ts">
    import type {LocalizeFunction} from '../svelte/types';
    import {getContext, onMount} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY, pipe} from '../svelte/utils';
    import type {Injector} from '../svelte/types';
    import {KpLocationsPresenter} from './kp-locations.presenter';
    import KpResponsiveGenericTable from '../commons/ui-components/table/KpResponsiveGenericTable.svelte';
    import {loc} from '../svelte/pipes';
    import type {Location} from '../typings/portaro.be.types';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const presenter: KpLocationsPresenter = injector.getByToken(KpLocationsPresenter.presenterName);

    let locations = [] as Location[];

    onMount(async () => {
        locations = await presenter.getAll();
    })

    async function switchLocation(location1: Location, location2: Location) {
        await presenter.switch(location1, location2);
        locations = await presenter.getAll();
    }

    async function create() {
        await presenter.create(locations);
        locations = await presenter.getAll();
    }

    async function remove(location: Location) {
        await presenter.remove(location);
        locations = await presenter.getAll();
    }

    async function edit(location: Location) {
        await presenter.edit(location);
        locations = await presenter.getAll();
    }

</script>

<div class="row">
    <div class="col-xs-12">
        <h1>{localize(/* @kp-localization commons.Locations */ 'commons.Locations')}</h1>
        <button type="button" class="btn btn-primary btn-sm pull-right" on:click={create}>
            <span class="glyphicon glyphicon-plus"></span>
            &nbsp;
            Vytvořit lokaci
        </button>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <KpResponsiveGenericTable hoverRows={true}>
                <slot slot="header">
                    <tr>
                        <th>#</th>
                        <th>
                            {localize( /* @kp-localization commons.Poradi */ 'commons.Poradi')}
                        </th>
                        <th>
                            {localize( /* @kp-localization commons.nazev */ 'commons.nazev')}
                        </th>
                        <th>
                            {localize( /* @kp-localization commons.Rentals */ 'commons.Rentals')}
                        </th>
                        <th>
                            {localize( /* @kp-localization commons.edit */ 'commons.edit')}
                        </th>
                    </tr>
                </slot>
                <slot slot="body">
                    {#each locations as location,index (location.id)}
                        <tr>
                            <td>{location.id}</td>
                            <td>{location.order}</td>
                            <td>
                                <span>{location.name}</span>
                                <br/>
                                <span class="text-muted">({location.text})</span>
                            </td>
                            <td>
                                <ul>
                                    {#each location.departments as department}
                                        <li>{department.id} - {pipe(department, loc())}</li>
                                    {/each}
                                </ul>
                            </td>
                            <td>
                                {#if location.editable || location.deletable}
                                    {#if location.editable && index !== 0}
                                        <button type="button" on:click={() => switchLocation(location, locations[index-1])} class="btn btn-default btn-xs"><span class="glyphicon glyphicon-arrow-up"></span></button>
                                    {/if}
                                    {#if location.editable && index !== locations.length - 1 }
                                        <button type="button" on:click={() => switchLocation(location, locations[index+1])} class="btn btn-default btn-xs"><span class="glyphicon glyphicon-arrow-down"></span>
                                        </button>
                                    {/if}
                                    {#if location.editable}
                                        <button type="button" on:click={() => edit(location)} class="btn btn-default btn-xs">{localize( /* @kp-localization commons.edit */ 'commons.edit')}</button>
                                    {/if}
                                    {#if location.deletable}
                                        <button type="button" on:click={() => remove(location)} class="btn btn-default btn-xs">{localize( /* @kp-localization commons.Smazat */ 'commons.Smazat')}</button>
                                    {/if}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </slot>
            </KpResponsiveGenericTable>
        </div>
    </div>
</div>